import { ICardInfoData } from "../interfaces/card-info.interface";

export const CARD_ICON_DIR = 'images/shared/cards';
export const NUMBER_ICON_DIR = 'images/shared/steps';

export const HealthcareMarketingInfo: ICardInfoData[] = [{
    icon: `${CARD_ICON_DIR}/rocket.png`,
    title: "expertise",
    text: "Explore the impact of artificial intelligence in diagnosing diseases and improving patient outcomes in modern healthcare."
},
{
    icon: `${CARD_ICON_DIR}/bulb.png`,
    title: "custom solutions",
    text: "Discuss the role of telemedicine in expanding healthcare access to rural and underserved populations."
},
{
    icon: `${CARD_ICON_DIR}/shield.png`,
    title: "security",
    text: "Analyze the ethical implications of genetic editing technologies in personalized medicine."
},
{
    icon: `${CARD_ICON_DIR}/rocket.png`,
    title: "support",
    text: "Examine how wearable health devices are transforming preventive care and chronic disease management."
}, {
    icon: `${CARD_ICON_DIR}/cheese.png`,
    title: "proven track record",
    text: "Investigate the challenges and opportunities of integrating mental health services into primary healthcare systems."
}]

export const HealthcareMarketingNumberedCardInfo: ICardInfoData[] = [{
    icon: `${NUMBER_ICON_DIR}/01.png`,
    title: "app development",
    text: "Versatile and reliable, SEM Nexus delivers seamless, tailored mobile health app development from start to finish."
},
{
    icon: `${NUMBER_ICON_DIR}/02.png`,
    title: "app marketing",
    text: "Data-driven marketing that delivers results—SEM Nexus connects your wellness or telemedicine app with the right audience."
},
{
    icon: `${NUMBER_ICON_DIR}/03.png`,
    title: "influencer marketing",
    text: "SEM Nexus uses influencers to make your app the talk of the town."
},
{
    icon: `${NUMBER_ICON_DIR}/04.png`,
    title: "website marketing",
    text: "SEM Nexus boosts your web traffic and conversions for care apps and recovery tools with measurable results."
}, {
    icon: `${NUMBER_ICON_DIR}/05.png`,
    title: "explore our work",
    text: "Our case studies showcase successful medical, health, and fitness apps built and marketed with proven strategies."
}]